import * as Yup from 'yup'

import { LONG_HEADLINES_LIST, RESOURCE_NAME } from '../../../../fields'

import { longHeadlineShape } from '../../../validations'

export const getInitialValues = assets => {
  return {
    [LONG_HEADLINES_LIST]: assets.map(({ [RESOURCE_NAME]: assetId, asset_data }) => ({
      text: asset_data.text_asset.text,
      id: assetId
    }))
  }
}

export const validationSchema = Yup.object({
  [LONG_HEADLINES_LIST]: Yup.array().of(longHeadlineShape)
})
